import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import PropTypes from 'prop-types';

class SwapImageIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayTooltip: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({
      displayTooltip: true,
    });
  }

  handleMouseLeave = () => {
    this.setState({
      displayTooltip: false,
    });
  }

  render() {
    const { displayTooltip } = this.state;

    const {
      connectDragSource,
      isChange,
      lang,
      isFit,
    } = this.props;


    if (isChange || isFit) {
      return false;
    }

    return connectDragSource(<div className="draggable">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <path d="M13.18 6.89l.71-.71-2.12-2.12L12.83 3H10v2.83l1.06-1.06zM2.82 9.11l-.71.71 2.12 2.12L3.17 13H6v-2.83l-1.06 1.06zM9 9v7h7V9zM0 7h7V0H0z" />s
      </svg>
      { displayTooltip && <div className="tooltip">{lang.draganddrop}</div> }
                             </div>);
  }
}

export default DragSource(
  'SwapImageIcon',
  {
    beginDrag(props) {
      const item = {
        id: props.placeholderId,
        type: 'SwapImage',
      };
      return item;
    },
    endDrag(props) {
      const draggedplaceholderId = props.placeholderId;
      return draggedplaceholderId;
    },
  },
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }),
)(SwapImageIcon);


SwapImageIcon.defaultProps = {
  connectDragSource: () => {},
  isChange: false,
  lang: {},
};

SwapImageIcon.propTypes = {
  connectDragSource: PropTypes.func,
  isChange: PropTypes.bool,
  lang: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/icons/SwapImageIcon.jsx